import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import "../styles/WaitingQueue.scss";
import {
  BackButton,
  Background,
  CharacterWithBubble,
  LanguageSelector,
} from "../components";
import {useWaitingQueue} from "../services/waitingQueue";
import {path} from "src/router/path";
import {useLocation, useNavigate} from "react-router-dom";
import {ARTIST, getArtistFromPath} from "src/utils/artist.utils";

const WaitingQueue = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("common");

  const {state} = useLocation();
  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const {waitingQueueInfo, enterCodeAllowed} = useWaitingQueue({
    registeredQueueInfo: state?.queueInfo,
  });

  const handleBack = () => {
    navigate(path.waiting(artist));
  };

  useEffect(() => {
    if (enterCodeAllowed) {
      navigate(path.code(artist), {replace: true});
    }
  }, [enterCodeAllowed, navigate, artist]);

  return (
    <div className="waiting-queue-container">
      <Background artist={artist} />
      <div className="waiting-queue-header">
        <BackButton artist={artist} onClick={handleBack} />
        <LanguageSelector artist={artist} />
      </div>
      <div className="waiting-queue-content">
        <div className="waiting-queue-label">
          <p className="waiting-queue-label-title">{t("queue.title")}</p>
          <p className="waiting-queue-label-description">
            {t("queue.description")}
          </p>
        </div>
        <div className="waiting-queue-body">
          <CharacterWithBubble
            content={
              <>
                <p className={`waiting-queue-sequence-label ${artist}`}>
                  {t("queue.sequenceLabel")}
                </p>
                <p className={`waiting-queue-sequence-value ${artist}`}>
                  {t("queue.sequence", {
                    position: waitingQueueInfo?.position ?? 0,
                  })}
                </p>
              </>
            }
            artist={artist}
            character={artist === ARTIST.aespa ? "karangi" : "rizuko"}
          />
          <p className="waiting-queue-notice">{t("queue.notice")}</p>
        </div>
      </div>
      <div />
    </div>
  );
};

export default WaitingQueue;
